<script lang="ts" setup>
import {
  faUser,
  faAddressBook,
  faCalendarDays,
  faArrowRightFromBracket,
  faCircleInfo,
  faHeadset,
  faGiftCard,
  faBriefcase,
  faCoins,
  faGear,
} from '@fortawesome/pro-light-svg-icons'
import type { CurrentUser } from '@consumer/types/serializers'
import { openHowGiftlyWorksModal } from '@consumer/services/modals'
import cardMasterLogo from '@consumer/assets/images/card-with-master-card-logo-sm.png'
import MenuItem from './MenuItem.vue'

const currentUser = inject<Ref<CurrentUser | null>>('currentUser')

// Bound to the mobile-menu open state in `UserMenuMobile.vue`. Setting it
// false on any interaction inside the menu ensures the mobile menu overlay
// dismisses when a link is followed (Inertia navigations don't unmount the
// modal on their own).
const open = defineModel<boolean>('open')
function closeMobileMenu () {
  if (open.value) open.value = false
}
</script>

<template>
  <div
    class="py-4 lg:p-3 flex flex-col lg:gap-3 border-b-1 border-grey-primary"
    @click="closeMobileMenu"
  >
    <template v-if="currentUser">
      <MenuItem
        label="Calendar"
        badge="New"
        :icon="faCalendarDays"
        iconColor="#00A2F1"
        iconBgColor="#F3F9FF"
        url="/my-account/calendar"
      />
      <MenuItem
        label="Contacts"
        :icon="faAddressBook"
        iconColor="#00A2F1"
        iconBgColor="#F3F9FF"
        url="/my-account/contacts/all"
      />
      <MenuItem
        label="Profile"
        :icon="faUser"
        iconColor="#00A2F1"
        iconBgColor="#F3F9FF"
        url="/my-account/profile"
      />
    </template>
    <template v-else>
      <MenuItem
        label="Sign Up"
        :icon="faUser"
        iconColor="#00A2F1"
        iconBgColor="#F3F9FF"
        url="/signup"
      />
      <MenuItem
        label="Login"
        :icon="faArrowRightFromBracket"
        iconColor="#00A2F1"
        iconBgColor="#F3F9FF"
        url="/login"
      />
    </template>
  </div>
  <div
    class="py-4 lg:p-3 flex flex-col lg:gap-3 border-b-1 border-grey-primary"
    @click="closeMobileMenu"
  >
    <MenuItem
      label="Activate new card"
      :image="cardMasterLogo"
      imageAlt="Giftly Card"
      iconBgColor="#F3F9FF"
      url="/card/activate"
    />
    <MenuItem
      label="Check balance"
      :icon="faCoins"
      iconColor="#00A2F1"
      iconBgColor="#F3F9FF"
      url="/card/access"
    />
    <MenuItem
      label="Manage my card"
      :icon="faGear"
      iconColor="#00A2F1"
      iconBgColor="#F3F9FF"
      url="/card/access"
    />
  </div>
  <div
    class="py-4 lg:p-3 flex flex-col lg:gap-3"
    @click="closeMobileMenu"
  >
    <MenuItem
      class="how-it-works-modal-link"
      label="How it works"
      :icon="faCircleInfo"
      iconColor="#00A2F1"
      iconBgColor="#F3F9FF"
      @click.prevent="openHowGiftlyWorksModal"
    />
    <MenuItem
      label="Help"
      :icon="faHeadset"
      iconColor="#A675C3"
      iconBgColor="#F7F0FA"
      url="/support"
    />
    <MenuItem
      label="Redeem"
      :icon="faGiftCard"
      iconColor="#FFBC10"
      iconBgColor="#FFF6DE"
      url="/entercode"
    />
    <MenuItem
      label="For Business"
      :icon="faBriefcase"
      iconColor="#AE3B00"
      iconBgColor="#FFDFCE"
      url="/corp"
    />
    <MenuItem
      v-if="currentUser"
      label="Logout"
      :icon="faArrowRightFromBracket"
      iconColor="#00A2F1"
      iconBgColor="#F3F9FF"
      url="/signout"
    />
  </div>
</template>
